export default __webpack_public_path__ + "static/media/zawema - Charte déontologique des vendeurs.fde332e0.pdf";